import type { Size } from "@volumental/common";

export const getExistingLocales = (sizeList: Size[]): string[] => {
  const list = sizeList.flatMap((x) => x.localizedSizes.map((t) => t.locale));
  const s = new Set(list);
  return [...s];
};
